export default {"src":"/_next/static/media/creadylogo.bd777ad2.svg","height":38,"width":165,"blurWidth":0,"blurHeight":0};